import i18n from "@/i18n";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";
import { IHookLog } from "@/models/hooks";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`,
      slots: (event: IHookLog) =>
        event.object?.fullname && [
          {
            slot: "name",
            is: "strong",
            message: `'${event.object.fullname}'`
          }
        ]
    })
  }
});

export default {
  ...createEventMap(HookCodes.USER_DELETED, {
    icon: {
      name: "trash-alt",
      pack: "far",
      type: "is-danger"
    }
  }),
  ...createEventMap(HookCodes.USER_CREATED, {
    icon: {
      name: "check-circle",
      type: "is-success"
    }
  }),
  ...createEventMap(HookCodes.API_USER_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.API_USER_DELETED, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.API_USER_UPDATED),
  ...createEventMap(HookCodes.API_USER_REFRESHED, {
    icon: {
      name: "sync-alt",
      type: "is-success"
    }
  }),
  ...createEventMap(HookCodes.API_USER_REVOKED, {
    icon: {
      name: "ban",
      type: "is-danger"
    }
  }),
  ...createEventMap(HookCodes.USER_CREATED_VERIFIED_CLIENT),
  ...createEventMap(HookCodes.USER_CREATED_UNVERIFIED_CLIENT),
  ...createEventMap(HookCodes.USER_UPDATED),
  ...createEventMap(HookCodes.USER_LOGGED_IN),
  ...createEventMap(HookCodes.USER_VERIFICATION_REQUIRED),
  ...createEventMap(HookCodes.USER_ADDED_TWO_FACTOR_AUTH),
  ...createEventMap(HookCodes.USER_REMOVED_TWO_FACTOR_AUTH),
  ...createEventMap(HookCodes.USER_PASSWORD_WAS_RESET),
  ...createEventMap(HookCodes.USER_REQUESTED_PASSWORD_RESET),
  ...createEventMap(HookCodes.USER_PASSWORD_CHANGED, {
    icon: icon.lock
  }),
  ...createEventMap(HookCodes.USER_WAS_IMPERSONATED),
  ...createEventMap(HookCodes.USER_EXCEEDED_MAX_INCORRECT_LOGINS, {
    icon: icon.warning
  })
};
